export default __webpack_public_path__ + "static/media/Paper.7371c2ba.png";